import body1 from "../assets/body/body1.png";
import body2 from "../assets/body/body2.png";
import body3 from "../assets/body/body3.png";
import body4 from "../assets/body/body4.png";
import body5 from "../assets/body/body5.png";
import body6 from "../assets/body/body6.png";
import body7 from "../assets/body/body7.png";
import body8 from "../assets/body/body8.png";
import body9 from "../assets/body/body9.png";
import body10 from "../assets/body/body10.png";
import body11 from "../assets/body/body11.png";
import body12 from "../assets/body/body12.png";

import hair1 from "../assets/hair/hair1.png";
import hair2 from "../assets/hair/hair2.png";
import hair3 from "../assets/hair/hair3.png";
import hair4 from "../assets/hair/hair4.png";
import hair5 from "../assets/hair/hair5.png";
import hair6 from "../assets/hair/hair6.png";
import hair7 from "../assets/hair/hair7.png";
import hair8 from "../assets/hair/hair8.png";
import hair9 from "../assets/hair/hair9.png";
import hair10 from "../assets/hair/hair10.png";
import hair11 from "../assets/hair/hair11.png";
import hair12 from "../assets/hair/hair12.png";
import hair13 from "../assets/hair/hair13.png";
import hair14 from "../assets/hair/hair14.png";
import hair15 from "../assets/hair/hair15.png";
import hair16 from "../assets/hair/hair16.png";
import hair17 from "../assets/hair/hair17.png";
import hair18 from "../assets/hair/hair18.png";
import hair19 from "../assets/hair/hair19.png";
import hair20 from "../assets/hair/hair20.png";
import hair21 from "../assets/hair/hair21.png";
import hair22 from "../assets/hair/hair22.png";
import hair23 from "../assets/hair/hair23.png";
import hair24 from "../assets/hair/hair24.png";
import hair25 from "../assets/hair/hair25.png";
import hair26 from "../assets/hair/hair26.png";
import hair27 from "../assets/hair/hair27.png";
import hair28 from "../assets/hair/hair28.png";
import hair29 from "../assets/hair/hair29.png";
import hair30 from "../assets/hair/hair30.png";
import hair31 from "../assets/hair/hair31.png";
import hair32 from "../assets/hair/hair32.png";
import hair33 from "../assets/hair/hair33.png";
import hair34 from "../assets/hair/hair34.png";
import hair35 from "../assets/hair/hair35.png";
import hair36 from "../assets/hair/hair36.png";
import hair37 from "../assets/hair/hair37.png";
import hair38 from "../assets/hair/hair38.png";
import hair39 from "../assets/hair/hair39.png";
import hair40 from "../assets/hair/hair40.png";
import hair41 from "../assets/hair/hair41.png";
import hair42 from "../assets/hair/hair42.png";
import hair43 from "../assets/hair/hair43.png";
import hair44 from "../assets/hair/hair44.png";
import hair45 from "../assets/hair/hair45.png";
import hair46 from "../assets/hair/hair46.png";
import hair47 from "../assets/hair/hair47.png";
import hair48 from "../assets/hair/hair48.png";
import hair49 from "../assets/hair/hair49.png";
import hair50 from "../assets/hair/hair50.png";
import hair51 from "../assets/hair/hair51.png";
import hair52 from "../assets/hair/hair52.png";
import hair53 from "../assets/hair/hair53.png";
import hair54 from "../assets/hair/hair54.png";
import hair55 from "../assets/hair/hair55.png";
import hair56 from "../assets/hair/hair56.png";
import hair57 from "../assets/hair/hair57.png";
import hair58 from "../assets/hair/hair58.png";
import hair59 from "../assets/hair/hair59.png";
import hair60 from "../assets/hair/hair60.png";
import hair61 from "../assets/hair/hair61.png";
import hair62 from "../assets/hair/hair62.png";
import hair63 from "../assets/hair/hair63.png";
import hair64 from "../assets/hair/hair64.png";
import hair65 from "../assets/hair/hair65.png";
import hair66 from "../assets/hair/hair66.png";
import hair67 from "../assets/hair/hair67.png";
import hair68 from "../assets/hair/hair68.png";
import hair69 from "../assets/hair/hair69.png";
import hair70 from "../assets/hair/hair70.png";
import hair71 from "../assets/hair/hair71.png";
import hair72 from "../assets/hair/hair72.png";
import hair73 from "../assets/hair/hair73.png";
import hair74 from "../assets/hair/hair74.png";
import hair75 from "../assets/hair/hair75.png";
import hair76 from "../assets/hair/hair76.png";
import hair77 from "../assets/hair/hair77.png";
import hair78 from "../assets/hair/hair78.png";
import hair79 from "../assets/hair/hair79.png";
import hair80 from "../assets/hair/hair80.png";
import hair81 from "../assets/hair/hair81.png";
import hair82 from "../assets/hair/hair82.png";
import hair83 from "../assets/hair/hair83.png";
import hair84 from "../assets/hair/hair84.png";

import face1 from "../assets/face/face1.png";
import face2 from "../assets/face/face2.png";
import face3 from "../assets/face/face3.png";
import face4 from "../assets/face/face4.png";
import face5 from "../assets/face/face5.png";
import face6 from "../assets/face/face6.png";
import face7 from "../assets/face/face7.png";
import face8 from "../assets/face/face8.png";
import face9 from "../assets/face/face9.png";
import face10 from "../assets/face/face10.png";
import face11 from "../assets/face/face11.png";
import face12 from "../assets/face/face12.png";
import face13 from "../assets/face/face13.png";
import face14 from "../assets/face/face14.png";
import face15 from "../assets/face/face15.png";
import face16 from "../assets/face/face16.png";
import face17 from "../assets/face/face17.png";
import face18 from "../assets/face/face18.png";
import face19 from "../assets/face/face19.png";
import face20 from "../assets/face/face20.png";
import face21 from "../assets/face/face21.png";
import face22 from "../assets/face/face22.png";

import top1 from "../assets/top/top1.png";
import top2 from "../assets/top/top2.png";
import top3 from "../assets/top/top3.png";
import top4 from "../assets/top/top4.png";
import top5 from "../assets/top/top5.png";
import top6 from "../assets/top/top6.png";
import top7 from "../assets/top/top7.png";
import top8 from "../assets/top/top8.png";
import top9 from "../assets/top/top9.png";

import bot1 from "../assets/bot/bot1.png";
import bot2 from "../assets/bot/bot2.png";
import bot3 from "../assets/bot/bot3.png";
import bot4 from "../assets/bot/bot4.png";
import bot5 from "../assets/bot/bot5.png";
import bot6 from "../assets/bot/bot6.png";
import bot7 from "../assets/bot/bot7.png";

import shoe1 from "../assets/shoe/shoe1.png";
import shoe2 from "../assets/shoe/shoe2.png";
import shoe3 from "../assets/shoe/shoe3.png";
import shoe4 from "../assets/shoe/shoe4.png";
import shoe5 from "../assets/shoe/shoe5.png";
import shoe6 from "../assets/shoe/shoe6.png";
import shoe7 from "../assets/shoe/shoe7.png";
import shoe8 from "../assets/shoe/shoe8.png";
import shoe9 from "../assets/shoe/shoe9.png";

import acc1 from "../assets/acc/acc1.png";
import acc2 from "../assets/acc/acc2.png";
import acc3 from "../assets/acc/acc3.png";
import acc4 from "../assets/acc/acc4.png";
import acc5 from "../assets/acc/acc5.png";
import acc6 from "../assets/acc/acc6.png";
import acc7 from "../assets/acc/acc7.png";
import acc8 from "../assets/acc/acc8.png";
import acc9 from "../assets/acc/acc9.png";
import acc10 from "../assets/acc/acc10.png";
import acc11 from "../assets/acc/acc11.png";
import acc12 from "../assets/acc/acc12.png";
import acc13 from "../assets/acc/acc13.png";
import acc14 from "../assets/acc/acc14.png";
import acc15 from "../assets/acc/acc15.png";

export const getBody = () => [
  body1,
  body2,
  body3,
  body4,
  body5,
  body6,
  body7,
  body8,
  body9,
  body10,
  body11,
  body12,
];

export const getHair = () => [
  hair1,
  hair2,
  hair3,
  hair4,
  hair5,
  hair6,
  hair7,
  hair8,
  hair9,
  hair10,
  hair11,
  hair12,
  hair13,
  hair14,
  hair15,
  hair16,
  hair17,
  hair18,
  hair19,
  hair20,
  hair21,
  hair22,
  hair23,
  hair24,
  hair25,
  hair26,
  hair27,
  hair28,
  hair29,
  hair30,
  hair31,
  hair32,
  hair33,
  hair34,
  hair35,
  hair36,
  hair37,
  hair38,
  hair39,
  hair40,
  hair41,
  hair42,
  hair43,
  hair44,
  hair45,
  hair46,
  hair47,
  hair48,
  hair49,
  hair50,
  hair51,
  hair52,
  hair53,
  hair54,
  hair55,
  hair56,
  hair57,
  hair58,
  hair59,
  hair60,
  hair61,
  hair62,
  hair63,
  hair64,
  hair65,
  hair66,
  hair67,
  hair68,
  hair69,
  hair70,
  hair71,
  hair72,
  hair73,
  hair74,
  hair75,
  hair76,
  hair77,
  hair78,
  hair79,
  hair80,
  hair81,
  hair82,
  hair83,
  hair84,
];

export const getFace = () => [
  face1,
  face2,
  face3,
  face4,
  face5,
  face6,
  face7,
  face8,
  face9,
  face10,
  face11,
  face12,
  face13,
  face14,
  face15,
  face16,
  face17,
  face18,
  face19,
  face20,
  face21,
  face22,
];

export const getTop = () => [
  top1,
  top2,
  top3,
  top4,
  top5,
  top6,
  top7,
  top8,
  top9,
];

export const getBottom = () => [bot1, bot2, bot3, bot4, bot5, bot6, bot7];

export const getShoes = () => [
  shoe1,
  shoe2,
  shoe3,
  shoe4,
  shoe5,
  shoe6,
  shoe7,
  shoe8,
  shoe9,
];

export const getAccessory = () => [
  acc1,
  acc2,
  acc3,
  acc4,
  acc5,
  acc6,
  acc7,
  acc8,
  acc9,
  acc10,
  acc11,
  acc12,
  acc13,
  acc14,
  acc15,
];
